<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2026-->

<div class="modal-header">
  <h3 class="modal-title">Your Dynamic Operating Pattern</h3>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <table class="table table-striped">
    <thead>
      <tr>
        <th>Dynamic</th>
        <th>Pattern for You</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows">
        <td><strong>{{ row.dynamic }}</strong></td>
        <td>{{ row.pattern }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="close()">Close</button>
</div>
